import React from 'react';
import AuctionIcon from '@tradera/blueprint/theme/icons2/auction.svg?jsx';
import { useTranslator, useUrlLocalizer } from 'tradera-lang/translate';

const OngoingAuctionsLink = () => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();

    return (
        <a
            href={toLocalizedUrl('/my/active-items')}
            rel="nofollow"
            aria-label={t('siteHeader_ongoingAuctions')}
            className="slim-header__menu-link slim-header__link-spacing d-flex align-items-center"
            data-ga-category="Top navigation"
            data-ga-action="Ongoing auction"
            data-ga-label="Link - Ongoing auctions from NavBar">
            <AuctionIcon className="icon icon-dark icon-md d-md-none d-block" />
        </a>
    );
};

export default OngoingAuctionsLink;
